/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'is-empty';
import PropTypes from 'prop-types';
import { UserMutualFund, MutualFundSavingPlans } from './index';
import getUserMutualFund from '../../../actions/mutualFunds.actions/getUserMutualFund';
import Questionaire from '../../user.authentication.components/quetionaire.components/Quetionaire';

/**
 * @class MutualFundOption
 */
class MutualFundOption extends Component {

  componentWillMount = () => {
    const { GetUserMutualFund } = this.props;
    GetUserMutualFund();
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const { mutualFund } = this.props;
    
    return (
      <>
        {
            !isEmpty(mutualFund)
              ? <UserMutualFund mutualFundList={mutualFund} />
              : <Questionaire />
        }
      </>
    );
  }
}

MutualFundOption.propTypes = {
  GetUserMutualFund: PropTypes.func,
  appTransaction: PropTypes.any,
  mutualFund: PropTypes.any,
};

const mapStateToProps = state => ({
  mutualFund: state.userMutualFund.mutualFunds
});

export default connect(mapStateToProps, {
  GetUserMutualFund: getUserMutualFund
})(MutualFundOption);
